<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-popup
      class="holamundo"
      title="Yarı Mamül Sil"
      :active.sync="deletePopupActive"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Yarı Mamülü Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>

    <vs-table
      ref="table"
      :data="halfMadeProducts"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row vs-type="flex" vs-w="12" class="mb-1">
          <global-filter
            ref="filterer"
            :tableOptions="tableOptions"
            :filterOptions="filterOptions"
            :filterChips="filterChips"
            :filterOptionNames="filterOptionNames"
            :isActive="isFilterActive"
            @saveOptions="saveOptions"
            @close="isFilterActive = false"
          />
          <vs-row
            id="panelHeaderRow"
            v-show="!isFilterActive"
            vs-type="flex"
            vs-w="12"
            vs-justify="space-between"
          >
            <vs-col
              id="panel-actions"
              vs-type="flex"
              class="w-auto"
              vs-justify="center"
            >
              <vs-row vs-type="flex" vs-w="12">
                <vs-col v-if="$isCenterBranch() && isNewHalfMadeProductPermission" vs-type="flex" class="w-auto">
                  <vx-tooltip text="Yeni Yarımamül" position="top">
                    <vs-button
                      @click="addNewData"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-type="flex" class="w-auto">
                  <vx-tooltip text="Detaylı Filtereleme" position="top">
                    <vs-button
                      @click="isFilterActive = !isFilterActive"
                      class="panel-action text-warning xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="pickicon"
                      icon="icon-pick-filter"
                    >
                    </vs-button>
                  </vx-tooltip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col id="filter-chips" vs-type="flex">
              <vs-row
                vs-type="flex"
                vs-w="12"
                vs-justify="center"
                vs-align="center"
              >
                <vs-button
                  id="clearFilterButton"
                  v-if="filterChips.length > 0"
                  @click="clearFilter"
                  class="mr-2 bg-white text-danger panel-action-box-shadow"
                  icon-pack="feather"
                  icon="icon-slash"
                  radius
                  color="transparent"
                />
                <vs-col
                  vs-type="flex"
                  class="w-auto"
                  v-for="(chip, index) in filterChips"
                  :key="index"
                >
                  <vs-chip
                    color="white"
                    class="panel-action-box-shadow px-1"
                    @click="removeFilter(chip.col, index)"
                    v-show="chip.value != ''"
                    closable
                  >
                    <vs-row vs-tpye="flex" vs-w="12">
                      <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                        <span class="bold text-xsmaller text-dark">
                          {{ chip.name + " :" }}
                        </span>
                      </vs-col>
                      <vs-col
                        vs-type="flex"
                        class="w-auto ml-1"
                        vs-align="center"
                      >
                        <span
                          class="weight-600 italic text-xsmaller text-primary"
                        >
                          {{ chip.value }}
                        </span>
                      </vs-col>
                    </vs-row>
                  </vs-chip>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col
              id="table-page-size"
              vs-type="flex"
              class="w-auto"
              vs-justify="flex-end"
            >
              <vs-dropdown
                vs-trigger-click
                class="bg-white cursor-pointer panel-action-box-shadow"
              >
                <div
                  class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                >
                  <span class="mr-2 page-size-dropdown-span"
                    >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                    -
                    {{
                      totalDataRow - (currentPage + 1) * itemsPerPage > 0
                        ? (currentPage + 1) * itemsPerPage
                        : totalDataRow
                    }}
                    of
                    {{ totalDataRow }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="itemsPerPage = 10">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 15">
                    <span>15</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="itemsPerPage = 20">
                    <span>20</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-col>
          </vs-row>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'halfMadeProduct.name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('halfMadeProduct.name')"
            >İsim</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'totalBuyPrice' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('totalBuyPrice')"
            >Maaliyet</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'halfMadeProduct.Unit.Name'
                ? sortingHeadIcon
                : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('halfMadeProduct.Unit.Name')"
            >Birim</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Hammaddeleri</vs-button
          >
        </vs-th>
        <vs-th>
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >Açıklama</vs-button
          >
        </vs-th>
        <vs-th v-if="$isCenterBranch()">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >İşlem</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ $toCurrency(tr.totalBuyPrice) }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.unit.name }}</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate m-auto" style="width: fit-content">
                <!-- <vs-chip v-for="recipeStep in tr.recipeSteps" :key="recipeStep.id">
                  {{recipeStep.rawMaterial.name}}({{recipeStep.unitPartQuantity}}
                  {{recipeStep.unit.shortName}})</vs-chip> -->
                <vs-chip>
                  {{ tr.recipeSteps.length }}
                </vs-chip>
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.description }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap" v-if="$isCenterBranch()">
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import GlobalFilter from "../GlobalFilter";
import PaginationDefault from "../PaginationDefault";
import DataViewSidebar from "./NewHalfMadeProductAdd.vue";
import moduleHalfMadeProduct from "@/store/halfMadeProduct/moduleHalfMadeProduct.js";
import { deleteHalfMadeProduct } from "@/api/HalfMadeProduct";
import {isGranted} from "@/utils/auth";
export default {
  components: {
    DataViewSidebar,
    PaginationDefault,
    GlobalFilter,
  },
  data() {
    return {
      deletedId: null,
      deletePopupActive: false,
      selected: "",

      tableOptions: {},
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      addNewDataSidebar: false,
      sidebarData: {},

      isFilterActive: false,
      filterOptions: ["branch", "halfMade", "rawMaterial", "cost"],
      filterOptionNames: ["Şube", "Yarımamül", "Hammadde", "Maaliyet"],
      filterChips: [],
    };
  },
  computed: {
    halfMadeProducts() {
      return this.$store.state.halfMadeProduct.halfMadeProducts;
    },
    totalDataRow() {
      return this.$store.state.halfMadeProduct.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    isNewHalfMadeProductPermission(){
      return isGranted("half_made_write")
    }
  },
  methods: {
    saveOptions(filterOptions, filterChips) {
      this.isFilterActive = false;
      if (_.isEqual(this.tableOptions, filterOptions)) return;
      this.tableOptions = _.cloneDeep(filterOptions);
      this.filterChips = _.cloneDeep(filterChips);
    },
    clearFilter() {
      this.tableOptions = {
        sortBy: "Id",
        sortDirection: "asc",
        pageIndex: 0,
        pageSize: this.itemsPerPage,

        branch: null,
        halfMade: null,
        cost: {
          min: null,
          max: null,
        },
        rawMaterial: null,
      };
      this.filterChips.length = 0;
    },
    removeFilter(col, index) {
      this.tableOptions[col] = null;
      this.filterChips.splice(index, 1);
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      deleteHalfMadeProduct(id)
        .then((res) => {
          if (res && res.status == 200) {
            this.$store
              .dispatch("halfMadeProduct/removeHalfMadeProduct", id)
              .then(() => {
                this.deletePopupActive = false;
                this.$vs.notify({
                  color: "success",
                  title: "Silme İşlemi",
                  text: "Yarı Mamül Başarıyla Silindi",
                });
              });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Yarı Mamül Silinemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
          });
        });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getHalfMadeProductList() {
      this.$store
        .dispatch(
          "halfMadeProduct/fetchDataListItemsHalfMadeProduct",
          this.tableOptions
        )
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    if (!moduleHalfMadeProduct.isRegistered) {
      this.$store.registerModule("halfMadeProduct", moduleHalfMadeProduct);
      moduleHalfMadeProduct.isRegistered = true;
    }
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
    this.clearFilter();
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.getHalfMadeProductList();
        });
      },
    },
    selected: function (val) {
      if (val != "" && this.$isCenterBranch()) this.editData(val);
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
    },
  },
};
</script>

<style>
.selectable:hover {
  cursor: pointer;
  box-shadow: 2px 2px 5px #000;
}
</style>
